/* src/app/features/indexadores/listagem/indexadores-listagem.component.scss */
/*# sourceMappingURL=indexadores-listagem.component.css.map */
